export default {
  issues: {
    subtasks: {
      hint: 'Подзадачи: {done} из {total} готово',
    },
    types: {
      ISSUE_TYPE_EPIC: 'Эпик',
      ISSUE_TYPE_STORY: 'История',
      ISSUE_TYPE_TASK: 'Задача',
      ISSUE_TYPE_BUG: 'Баг',
      ISSUE_TYPE_SUBTASK: 'Подзадача',
    },
    priorities: {
      PRIORITY_HIGHEST: 'Наивысший',
      PRIORITY_HIGH: 'Высокий',
      PRIORITY_MEDIUM: 'Средний',
      PRIORITY_LOW: 'Низкий',
      PRIORITY_LOWEST: 'Низший',
    },
    create: {
      action: 'Создать задачу',
      inColumn: 'Задача',
      title: 'Новая задача',
      type: 'Тип',
      name: 'Название',
      namePlaceholder: 'Что нужно сделать',
      description: 'Описание',
      descriptionPlaceholder: 'Подробности, ссылки, критерии готовности',
      priority: 'Приоритет',
      assignee: 'Исполнитель',
      assigneePlaceholder: 'Не назначен',
      noMembers: 'В проекте пока никого',
      parent: 'Родитель',
      parentPlaceholder: 'Без родителя',
      noParents: 'Подходящих задач нет',
      dueDate: 'Срок',
      submit: 'Создать',
      created: 'Задача {key} создана',
      errors: {
        title: 'Название не длиннее {limit} знаков',
        failed: 'Не удалось создать задачу',
      },
    },
    list: {
      columns: {
        type: 'Тип',
        key: 'Ключ',
        title: 'Название',
        status: 'Статус',
        priority: 'Пр.',
        assignee: 'Исп.',
        due: 'Срок',
      },
      groupBy: {
        label: 'Группировка',
        status: 'статус',
        assignee: 'исполнитель',
        priority: 'приоритет',
        type: 'тип',
        none: 'без групп',
      },
      select: 'Отметить {key}',
      selectAll: 'Отметить все на странице',
      selected: 'Отмечена {count} задача | Отмечено {count} задачи | Отмечено {count} задач',
      clearSelection: 'Снять отметки',
      bulk: {
        label: 'Действия над отмеченными',
        status: 'Статус',
        assignee: 'Исполнитель',
      },
      shown: 'Показано {shown} из {total}',
      pages: 'Страницы списка',
      prev: 'Предыдущая страница',
      next: 'Следующая страница',
      openIssue: 'Открыть задачу {key}',
      changeStatus: 'Сменить статус',
      changeAssignee: 'Сменить исполнителя',
      assignFailed: 'Не удалось сменить исполнителя',
      noAssignee: 'Без исполнителя',
      noStatus: 'Без статуса',
      noPriority: 'Без приоритета',
      noType: 'Без типа',
      empty: {
        title: 'Задач пока нет',
        description: 'Создайте первую — она появится и в списке, и на доске проекта.',
      },
      error: {
        title: 'Не удалось загрузить список',
        description: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
      },
    },
  },
  issue: {
    back: 'Назад',
    titleLabel: 'Название задачи',
    saveFailed: 'Не удалось сохранить изменение',
    today: 'сегодня',
    yesterday: 'вчера',
    watch: 'Подписаться',
    unwatch: 'Отписаться',
    description: {
      empty: 'Добавить описание: условия, ссылки, критерии готовности',
      edit: 'Нажмите, чтобы править',
    },
    history: {
      none: 'Изменений пока не было',
      more: 'Показать ещё',
      system: 'Система',
      created: ' завела задачу',
      changed: ' изменила {field}:',
      empty: '—',
      fields: {
        title: 'название',
        description: 'описание',
        type: 'тип',
        priority: 'приоритет',
        assignee: 'исполнителя',
        parent: 'родителя',
        due_date: 'срок',
        column: 'статус',
        labels: 'метки',
        attributes: 'атрибуты',
        deleted: 'удаление',
      },
    },
    subtasks: {
      title: 'Подзадачи',
      add: 'Добавить подзадачу',
      placeholder: 'Что нужно сделать',
      failed: 'Не удалось завести подзадачу',
    },
    links: {
      empty: 'Связей пока нет',
      search: 'Ключ или название задачи',
      remove: 'Убрать связь с {key}',
      types: {
        LINK_TYPE_BLOCKS: 'Блокирует',
        LINK_TYPE_RELATES: 'Связана с',
        LINK_TYPE_DUPLICATES: 'Дублирует',
        LINK_TYPE_CAUSES: 'Приводит к',
      },
      outbound: {
        LINK_TYPE_BLOCKS: 'блокирует',
        LINK_TYPE_RELATES: 'связана с',
        LINK_TYPE_DUPLICATES: 'дублирует',
        LINK_TYPE_CAUSES: 'приводит к',
      },
      inbound: {
        LINK_TYPE_BLOCKS: 'заблокирована задачей',
        LINK_TYPE_RELATES: 'связана с',
        LINK_TYPE_DUPLICATES: 'дублируется задачей',
        LINK_TYPE_CAUSES: 'вызвана задачей',
      },
    },
    comments: {
      // Собака в тексте экранируется: vue-i18n читает «@» как ссылку на
      // другой ключ и падает на разборе сообщения целиком.
      placeholder: "Комментарий… ({'@'} — упомянуть, DEV-NNN — ссылка на задачу)",
      send: 'Отправить',
      empty: 'Комментариев пока нет',
      more: 'Показать более ранние',
      edit: 'Изменить',
      remove: 'Удалить',
    },
    peek: {
      open: 'Открыть страницу',
      activity: 'Активность',
    },
    dev: {
      title: 'GitLab',
      mr: {
        opened: 'Ревью',
        merged: 'Смержен',
        closed: 'Закрыт',
        draft: 'Черновик',
      },
      stand: {
        live: 'Стенд активен',
        removed: 'Стенд погашен',
      },
      pipeline: {
        success: 'Пайплайн прошёл',
        failed: 'Пайплайн упал',
        running: 'Пайплайн идёт',
        pending: 'Пайплайн в очереди',
        created: 'Пайплайн создан',
        canceled: 'Пайплайн отменён',
        skipped: 'Пайплайн пропущен',
        manual: 'Пайплайн ждёт запуска',
      },
    },
    pages: {
      title: 'База знаний',
      add: 'Привязать страницу',
      search: 'Название или текст страницы',
      nothing: 'Ничего не нашлось',
      remove: 'Отвязать страницу «{title}»',
    },
    attachments: {
      title: 'Вложения',
      add: 'Прикрепить файл',
      sending: 'Загружаем…',
      remove: 'Удалить файл {name}',
      count: '{count} файл | {count} файла | {count} файлов',
      kb: 'КБ',
      mb: 'МБ',
    },
    labels: {
      add: 'Добавить метку',
      remove: 'Снять метку {name}',
      search: 'Метка или новое имя',
      create: 'Создать «{name}»',
      none: 'В проекте пока нет меток',
    },
    activity: {
      label: 'Активность задачи',
      comments: 'Комментарии',
      history: 'История',
      links: 'Связи',
    },
    meta: {
      fold: 'Детали · исполнитель, срок, метки',
      status: 'Статус',
      assignee: 'Исполнитель',
      reporter: 'Автор',
      priority: 'Приоритет',
      due: 'Срок',
      noDue: 'Без срока',
      labels: 'Метки',
      services: 'Сервисы',
      watchers: 'Наблюдатели',
      addWatcher: 'Добавить наблюдателя',
      epic: 'Эпик',
      project: 'Проект',
      crm: 'Связь с CRM',
      crmKinds: {
        deal: 'Сделка',
        client: 'Клиент',
        agent: 'Агент',
      },
      created: 'Создана {date}',
      updated: 'Обновлена {date}',
    },
    error: {
      title: 'Не удалось загрузить задачу',
      description: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
    },
  },
  board: {
    dropHere: 'Отпустите, чтобы перенести',
    loadMore: 'Показать ещё {count}',
    loadingMore: 'Загружаем…',
    moveFailed: 'Не удалось перенести задачу',
    scrollToEnd: 'К последней колонке',
    scrollToStart: 'К первой колонке',
    nothingFound: {
      title: 'Ничего не нашлось',
      description:
        'Задачи есть, но ни одна не подходит под отбор. Снимите фильтр или измените запрос.',
    },
    empty: {
      title: 'Доска пуста',
      description: 'Создайте первую задачу — или перетащите сюда карточку из другой колонки.',
    },
    error: {
      title: 'Не удалось загрузить доску',
      description: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
      retry: 'Повторить',
    },
  },
  projects: {
    summary: {
      projects: '{count} проект | {count} проекта | {count} проектов',
      issues: '{count} открытая задача | {count} открытые задачи | {count} открытых задач',
      mine: 'вы участник в {count}',
    },
    searchPlaceholder: 'Поиск по проектам…',
    filters: {
      label: 'Какие проекты показывать',
      all: 'Все',
      mine: 'Мои',
      archived: 'Архив',
    },
    card: {
      inProgress: '{count} в раб',
      open: '{count} откр',
      private: 'Приватный проект',
    },
    empty: {
      title: 'Пока нет проектов',
      description: 'Создайте первый проект — ключ, название и профиль типов задач.',
    },
    nothingFound: {
      title: 'Ничего не нашлось',
      description: 'Попробуйте другой запрос или снимите фильтр.',
    },
    error: {
      title: 'Не удалось загрузить проекты',
      description: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
      retry: 'Повторить',
    },
    create: {
      action: 'Создать проект',
      title: 'Новый проект',
      key: 'Ключ',
      keyPlaceholder: 'DEV',
      name: 'Название',
      namePlaceholder: 'Разработка',
      description: 'Описание',
      descriptionPlaceholder: 'О чём проект и кто в нём работает',
      profile: 'Профиль проекта',
      profiles: {
        development: 'Разработка',
        simple: 'Простой',
      },
      profileHint: {
        development:
          'Эпик, история, задача, баг, подзадача. Доска: бэклог, к работе, в работе, ревью, тестирование, готово.',
        simple: 'Только задачи и подзадачи. Доска: к работе, в работе, готово.',
      },
      private: 'Приватный проект',
      privateHint: 'Приватный проект виден только его участникам.',
      submit: 'Создать',
      errors: {
        key: 'Заглавные латинские буквы, от двух до десяти',
        failed: 'Не удалось создать проект',
      },
    },
  },
  settings: {
    personal: {
      title: 'Настройки',
    },
    integrations: {
      title: 'Интеграции',
      connect: {
        title: 'Подключить агента',
        step1: 'Выпустите ключ доступа',
        step2: 'Выполните команду в терминале',
        step2Hint: 'Подставьте выпущенный ключ вместо многоточия: трекер его не хранит и показать второй раз не сможет.',
        copy: 'Скопировать',
        copied: 'Скопировано',
        repo: '— исходники MCP-сервера и полный список инструментов',
      },
      keys: {
        title: 'Ключи доступа',
        hint: 'Ключ действует от вашего имени и не может больше, чем можете вы. До {limit} активных.',
        hintNoLimit: 'Ключ действует от вашего имени и не может больше, чем можете вы.',
        issue: 'Выпустить ключ',
        revoke: 'Отозвать',
        revoked: 'Ключ «{name}» отозван',
        empty: 'Ключей пока нет',
        emptyHint: 'Выпустите первый кнопкой выше — он появится в этом списке.',
        until: 'до {date}',
        revokedAt: 'отозван {date}',
        expired: 'истёк',
        neverUsed: 'не использовался',
        today: 'сегодня, {time}',
        yesterday: 'вчера',
        daysAgo: '{n} день назад | {n} дня назад | {n} дней назад',
        columns: {
          name: 'Имя',
          access: 'Доступ',
          lastUsed: 'Последнее обращение',
          expiry: 'Срок',
        },
        scopes: {
          all: 'все ваши права',
          tasks: 'задачи',
          tasksRead: 'задачи — только чтение',
          knowledge: 'база знаний',
        },
      },
      capabilities: {
        title: 'Что агент делает вашим ключом',
        reads: {
          title: 'Читает',
          items: [
            'Проекты, доски, колонки и метки',
            'Задачи, комментарии, историю и связи',
            'Ветки, MR и пайплайны задачи',
            'Страницы базы знаний',
          ],
        },
        writes: {
          title: 'Меняет',
          items: [
            'Создаёт задачи по одной и пачкой',
            'Правит поля и описание',
            'Переносит по колонкам, ставит метки',
            'Пишет комментарии и связывает задачи',
          ],
        },
        cannot: {
          title: 'Не может',
          items: [
            'Запускать релизы и менять флаги',
            'Поднимать и гасить фича-стенды',
            'Удалять задачи, проекты и страницы',
            'Выпускать новые ключи',
          ],
        },
      },
      dialog: {
        title: 'Выпустить ключ доступа',
        doneTitle: 'Ключ выпущен',
        name: 'Название',
        namePlaceholder: 'Claude Code · ноутбук',
        access: 'Доступ',
        scopeHint: 'Ключ не может больше, чем можете вы: права пересекаются с вашими. Релизы, флаги и стенды в ключ не входят никогда.',
        scopes: {
          'tracker:read': 'Задачи — чтение',
          'tracker:write': 'Задачи — запись',
          'knowledge:read': 'База знаний — чтение',
          'knowledge:write': 'База знаний — запись',
        },
        lifetime: 'Срок действия',
        ttl: {
          API_KEY_TTL_30_DAYS: '30 дней',
          API_KEY_TTL_90_DAYS: '90 дней',
          API_KEY_TTL_180_DAYS: '180 дней',
          API_KEY_TTL_365_DAYS: 'Год',
        },
        submit: 'Выпустить',
        done: 'Готово',
        secretHint: 'Скопируйте ключ сейчас: он показывается один раз и больше нигде не появится.',
        secretWarning: 'Ключ работает от вашего имени. Не кладите его в репозиторий и не пересылайте в переписке.',
        errors: {
          create: 'Не удалось выпустить ключ',
        },
      },
      errors: {
        load: 'Не удалось загрузить ключи',
        revoke: 'Не удалось отозвать ключ',
        copy: 'Буфер обмена недоступен',
      },
    },
    cancel: 'Отменить',
    save: 'Сохранить',
    saved: 'Настройки сохранены',
    saveFailed: 'Не удалось сохранить настройки',
    error: {
      title: 'Не удалось загрузить настройки',
      description: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
    },
    tabs: {
      columns: 'Колонки',
      members: 'Участники',
      types: 'Типы задач',
      general: 'Общее',
    },
    columns: {
      preset: 'Пресет:',
      presets: {
        COLUMN_PRESET_DEVELOPMENT: 'Разработка · 6 колонок с WIP',
        COLUMN_PRESET_SIMPLE: 'Общий · 3 колонки без лимитов',
      },
      presetLocked:
        'Пресет заменяет доску целиком, поэтому ложится только на пустой проект — в этом задачи уже есть.',
      hint: 'Пресет задаёт стартовый набор колонок. Дальше их можно править: имя, цвет, категория статуса и WIP-лимит.',
      categories: {
        STATUS_CATEGORY_OPEN: 'Открытые',
        STATUS_CATEGORY_IN_PROGRESS: 'В работе',
        STATUS_CATEGORY_DONE: 'Завершённые',
      },
      name: 'Название колонки',
      color: 'Цвет колонки',
      wip: 'WIP:',
      wipLabel: 'WIP-лимит колонки {name}',
      remove: 'Удалить колонку {name}',
      add: 'Добавить колонку',
      newName: 'Новая колонка',
      moveTitle: 'Куда перенести задачи',
      moveText:
        'В колонке {count} задача — выберите, куда её перенести. | В колонке {count} задачи — выберите, куда их перенести. | В колонке {count} задач — выберите, куда их перенести.',
      moveTarget: 'Колонка назначения',
      moveSubmit: 'Убрать колонку',
    },
    members: {
      remove: 'Убрать {name} из проекта',
      title: 'Участники',
      searchPlaceholder: 'Имя или почта сотрудника VINPROP',
      role: 'Роль',
      add: 'Добавить',
      nobody: 'Никого не нашлось',
      noDirectory: 'Справочник сотрудников недоступен: нужно право users:read',
      directoryRoles: {
        ADMIN: 'Администратор',
        ADMIN_USER: 'Администратор',
        CEO: 'Руководство',
        HOS: 'Руководитель продаж',
        PROJECT_MANAGER: 'Менеджер проекта',
        MANAGER: 'Менеджер',
        MARKETER: 'Маркетинг',
        SUPPORT_MANAGER: 'Поддержка',
        CONTENT_AUTHOR: 'Контент',
      },
      roles: {
        MEMBER_ROLE_ADMIN: 'Админ',
        MEMBER_ROLE_MEMBER: 'Участник',
        MEMBER_ROLE_VIEWER: 'Наблюдатель',
      },
      hint: 'Админ — настройки, участники и удаление задач. Участник — работа с задачами и доской. Наблюдатель — только чтение. Сам доступ к трекеру выдаётся в auth.',
    },
    types: {
      profiles: {
        TYPE_PROFILE_DEVELOPMENT: 'Профиль: разработка',
        TYPE_PROFILE_SIMPLE: 'Профиль: простой',
      },
      hint: 'Набор типов фиксированный: иерархия Эпик → История → Задача и Баг → Подзадача. Профиль включает и выключает типы, свои типы не заводятся.',
      notes: {
        ISSUE_TYPE_EPIC: 'Верхний уровень: цель на несколько недель, собирает истории и задачи',
        ISSUE_TYPE_STORY: 'Пользовательская ценность, делится на задачи',
        ISSUE_TYPE_TASK: 'Единица работы одного исполнителя',
        ISSUE_TYPE_BUG: 'Дефект: отдельный цвет и приоритет по умолчанию «высокий»',
        ISSUE_TYPE_SUBTASK: 'Чек-лист внутри задачи, не попадает на доску',
      },
      count: '{count} задача | {count} задачи | {count} задач',
    },
    general: {
      archive: 'Архив',
      archiveTitle: 'Архивировать проект',
      restoreTitle: 'Вернуть проект из архива',
      archiveNote:
        'Архивный проект уходит из хаба и из сайдбара. Задачи остаются доступны по ссылке.',
      archiveAction: 'Архивировать',
      restoreAction: 'Вернуть',
      archiveAsk: 'Проект пропадёт из хаба и навигации. Вернуть его можно на этом же экране.',
      restoreAsk: 'Проект снова появится в хабе и в сайдбаре.',
      archived: 'Проект в архиве',
      restored: 'Проект возвращён',
      name: 'Название проекта',
      key: 'Ключ',
      keyNote: 'Ключ менять нельзя: на нём завязаны номера задач и привязка веток GitLab.',
      description: 'Описание',
      access: 'Доступ и правила',
      private: 'Приватный проект',
      privateNote: 'Виден только участникам проекта и администраторам',
    },
  },
  editor: {
    mention: {
      empty: 'Никого не нашлось',
    },
  },
  app: {
    name: 'VP Tracker',
  },
  login: {
    title: 'Вход',
    email: 'Email',
    emailPlaceholder: "mk{'@'}vinprop.vn",
    password: 'Пароль',
    passwordPlaceholder: '••••••••••',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    submit: 'Войти',
    or: 'или',
    google: 'Войти через Google Workspace',
    footer: "Доступ выдаёт администратор VINPROP · vp-adm{'@'}vinprop.vn",
    errors: {
      invalid: 'Неверная почта или пароль',
      unavailable: 'Сервис входа недоступен. Попробуйте ещё раз через минуту',
    },
  },
  nav: {
    knowledgeShort: 'КБ',
    myTasksShort: 'Мои',
    mobile: 'Навигация',
    myTasks: 'Мои задачи',
    projects: 'Проекты',
    calendar: 'Календарь',
    devops: 'DevOps',
    knowledge: 'База знаний',
    assistant: 'Ассистент',
    projectsOverline: 'Проекты',
    addProject: 'Добавить проект',
    board: 'Доска',
    issues: 'Задачи',
    epics: 'Эпики',
    projectSettings: 'Настройки проекта',
    settings: 'Настройки',
    userMenu: 'Меню пользователя',
    collapse: 'Свернуть меню',
    expand: 'Развернуть меню',
    logout: 'Выйти',
  },
  toolbar: {
    search: 'Поиск…',
    create: 'Создать',
    view: {
      label: 'Вид проекта',
      board: 'Доска',
      list: 'Список',
    },
    filters: {
      assignee: 'Исполнитель',
      type: 'Тип',
      priority: 'Приоритет',
      reset: 'Сбросить',
      empty: 'Выбирать не из чего',
    },
  },
  views: {
    board: 'Доска',
    issues: 'Задачи',
    epics: 'Эпики',
    calendar: 'Календарь',
    devops: 'DevOps',
    knowledge: 'База знаний',
    myTasks: 'Мои задачи',
    settings: 'Настройки проекта',
  },
  errors: {
    forbidden: {
      ask: 'Запросить доступ',
      asked: 'Запрос отправлен. Администраторы проекта увидят его в уведомлениях.',
      askFailed: 'Не удалось отправить запрос',
      title: 'Нет доступа к проекту',
      description: 'Проект приватный. Запросите доступ у администратора проекта.',
    },
    notFound: {
      title: 'Страница не найдена',
      description:
        'Проверьте адрес: раздел мог быть переименован, а задача — удалена или перенесена.',
    },
    back: 'К моим задачам',
  },
  assistant: {
    title: 'Ассистент',
    you: 'Вы',
    close: 'Закрыть панель',
    history: 'Прошлые разговоры',
    newThread: 'Новый разговор',
    noThreads: 'Разговоров об этой странице ещё не было',
    untitled: 'Без названия',
    resize: 'Ширина панели',
    placeholder: 'Спросите или дайте команду…',
    stop: 'Остановить',
    waiting: 'Пишет ответ…',
    quota: 'Сегодня осталось {remaining} из {limit} обращений',
    limit: {
      at: 'Дневной лимит исчерпан. Обновится в {time}',
      later: 'Дневной лимит исчерпан. Обновится завтра',
    },
    unavailable: {
      title: 'Ассистент временно недоступен',
      text: 'Не отвечает сервис моделей. История разговора сохранена — попробуйте ещё раз через минуту.',
      retry: 'Повторить',
    },
    disclaimer:
      'Ассистент видит открытую страницу и работает с задачами от вашего имени. Вопрос и прочитанные им задачи уходят в Google Gemini — не вставляйте персональные данные клиентов.',
    suggestions: {
      board: 'Резюмируй, что происходит на доске',
      overdue: 'Что просрочено в проекте DEV',
      compose: 'Оформи задачу из моего текста',
    },
    tool: {
      running: 'идёт…',
      failed: 'не удалось',
      retry: 'Повторить',
      seconds: '{value} с',
      issues: '{n} задача | {n} задачи | {n} задач',
      pages: '{n} страница | {n} страницы | {n} страниц',
    },
    draft: {
      badge: 'черновик',
      field: {
        title: 'заголовок',
        description_md: 'описание',
      },
      inEpic: 'в {key}',
      apply: 'Применить',
      create: 'Создать {n} задачу | Создать {n} задачи | Создать {n} задач',
      decline: 'Отменить',
      applied: 'Применено',
      declined: 'Отклонено',
    },
    context: {
      board: 'Доска',
      issues: 'Задачи',
      epics: 'Эпики',
      'project-settings': 'Настройки проекта',
      'knowledge-page': 'Страница базы знаний',
      'knowledge-page-edit': 'Страница базы знаний',
      'my-tasks': 'Мои задачи',
      projects: 'Проекты',
      calendar: 'Календарь',
    },
    errors: {
      thread: 'Не удалось открыть разговор',
      stream: 'Ассистент недоступен, попробуйте ещё раз',
    },
  },
  palette: {
    tab: 'Поиск',
    title: 'Спросить ассистента или перейти',
    placeholder: 'Спросите или дайте команду…',
    hint: 'Наберите два знака: найдём страницу. Ключ вида DEV-1421 откроет задачу.',
    nothing: 'Ничего не нашлось',
    openIssue: 'Открыть задачу {key}',
    groups: {
      ask: 'Спросить',
      find: 'Найти',
      create: 'Создать',
      understand: 'Понять',
      jump: 'Перейти',
    },
    meta: {
      assistant: 'ассистент',
      knowledge: 'база знаний',
      draft: 'черновик',
    },
    commands: {
      mine: 'Мои задачи на этой неделе',
      overdue: 'Что просрочено в проекте {key}',
      overdueAll: 'Что просрочено в моих проектах',
      knowledge: 'Ответ по базе знаний',
      knowledgeFill: 'Ответь по базе знаний: ',
      compose: 'Оформить задачу из текста',
      composeFill: 'Оформи задачу из текста: ',
      decompose: 'Разложить эпик на задачи',
      decomposeFill: 'Разложи на задачи эпик ',
      stuck: 'Почему задача висит',
      stuckIssue: 'Почему {key} висит',
      stuckFill: 'Почему висит задача ',
      digest: 'Резюме доски за неделю',
    },
    footer: {
      select: '↑↓ выбрать',
      run: '↵ выполнить',
      next: '↵ следующий вопрос',
      here: 'Ответ появится здесь же',
      expand: 'Развернуть в панель',
    },
  },
  onboarding: {
    title: 'Начало работы · {done} из {total}',
    steps: {
      project: 'Создайте проект',
      issue: 'Создайте первую задачу',
      columns: 'Настройте колонки доски',
      team: 'Пригласите команду',
    },
  },
  calendar: {
    scope: {
      label: 'Чьи задачи',
      mine: 'Мои',
      watching: 'За кем слежу',
    },
    today: 'Сегодня',
    prev: 'Предыдущий месяц',
    next: 'Следующий месяц',
    more: 'ещё {count}',
    empty: 'В этом месяце сроков нет.',
    withoutDue: 'Без срока: {count}',
    error: {
      title: 'Не удалось открыть календарь',
      description: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
    },
  },
  hub: {
    activity: {
      title: 'Недавняя активность',
      empty: 'Событий пока не было. Здесь появятся заведённые задачи, комментарии и выкатки.',
      someone: 'Кто-то',
      today: 'Сегодня',
      yesterday: 'Вчера',
      more: 'Показать ещё',
      loading: 'Загружаем…',
      verbs: {
        created: 'завела задачу',
        moved: 'перенесла',
        comment: 'прокомментировала',
        merged: 'смержил',
        devops: 'выкатил',
        other: 'изменила',
      },
    },
  },
  kb: {
    space: 'Пространство',
    updated: 'обновлено {when}',
    version: 'версия {version}',
    related: 'Связанные задачи',
    error: {
      title: 'Не удалось открыть базу знаний',
      description: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
    },
    empty: {
      title: 'База знаний пуста',
      description: 'Пространств пока нет — заведите первое, и страницы появятся в сайдбаре.',
    },
    pick: {
      title: 'Выберите страницу',
      description: 'Дерево пространства — в сайдбаре слева.',
    },
    newSpace: {
      title: 'Новое пространство',
      key: 'Ключ',
      keyInvalid: 'Заглавные латинские буквы и цифры, от двух до шестнадцати',
      name: 'Название',
      create: 'Создать пространство',
      failed: 'Не удалось создать пространство',
    },
    blank: {
      title: 'В базе знаний пусто',
      description: 'Напишите первую страницу — она встанет в дерево слева.',
      create: 'Создать страницу',
    },
    edit: {
      action: 'Править',
      cancel: 'Отменить',
      crumb: '{title} — редактирование',
      titleLabel: 'Заголовок страницы',
      titlePlaceholder: 'Заголовок страницы',
      bodyPlaceholder: "Текст страницы. / — блоки, {'@'} — упоминание",
      savedAt: '✓ Черновик сохранён {time}',
      saveVersion: 'Сохранить версию',
      saveFailed: 'Не удалось сохранить страницу',
      versionSaved: 'Версия сохранена',
      restored: 'Восстановлена версия v{number}',
      previewing: 'Просмотр версии v{number}',
      closePreview: 'Закрыть просмотр',
      commentLabel: 'Что изменилось',
      commentPlaceholder: 'Необязательно: одна строка для истории',
    },
    versions: {
      title: 'Версии',
      empty: 'Версий пока нет. Кнопка «Сохранить версию» делает снимок страницы.',
      number: 'v{number}',
      current: 'текущая',
      open: 'Открыть',
      restore: 'Восстановить',
    },
    tree: {
      menu: 'Действия со страницей',
      addChild: 'Добавить подстраницу',
      move: 'Переместить',
      delete: 'Удалить',
      newPage: 'Новая страница',
      newPageTitle: 'Новая страница',
      newParent: 'Куда переместить',
      root: 'В корень пространства',
      moveTitle: 'Переместить «{title}»',
      deleteTitle: 'Удалить «{title}»?',
      deleteHint: 'Страницу вернуть будет нельзя.',
      deleteWithChildren: 'Вместе со страницей удалятся все вложенные. Вернуть их будет нельзя.',
      createFailed: 'Не удалось создать страницу',
      moveFailed: 'Не удалось переместить страницу',
      deleteFailed: 'Не удалось удалить страницу',
    },
  },
  my: {
    filters: {
      project: 'Проект',
      statusLabel: 'Статус',
      status: {
        STATUS_CATEGORY_OPEN: 'К работе',
        STATUS_CATEGORY_IN_PROGRESS: 'В работе',
        STATUS_CATEGORY_DONE: 'Готово',
      },
      dueLabel: 'Срок',
      due: {
        today: 'На сегодня',
        week: 'На неделю',
      },
    },
    sort: {
      label: 'Порядок',
      due_date: 'По сроку',
      priority: 'По приоритету',
      updated_at: 'По обновлению',
      key: 'По ключу',
    },
    chips: {
      assigned: 'Назначено мне',
      watching: 'Наблюдаю',
      overdue: 'Просрочено',
    },
    due: {
      today: 'сегодня',
      tomorrow: 'завтра',
    },
    error: 'Не удалось загрузить задачи',
    errorHint: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
    empty: {
      assigned: {
        title: 'На вас ничего не назначено',
        description: 'Задачи появятся здесь, как только вас назначат исполнителем.',
      },
      watching: {
        title: 'Вы ни за чем не наблюдаете',
        description: 'Подпишитесь на задачу кнопкой «Подписаться» — она попадёт сюда.',
      },
      overdue: {
        title: 'Просроченного нет',
        description: 'Все сроки пока в будущем.',
      },
    },
  },
  epic: {
    list: {
        stand: {
          raise: 'Собрать стенд',
          started: 'Стенд {key} собирается — сервисы задач эпика едут в один namespace',
          failed: 'Не удалось собрать стенд эпика',
        },
      search: 'Поиск по эпикам…',
      create: 'Создать эпик',
      due: 'срок {date}',
      error: {
        title: 'Не удалось загрузить эпики',
        description: 'Сервис не ответил. Проверьте связь и попробуйте ещё раз.',
      },
      empty: {
        title: 'Эпиков в проекте нет',
        description:
          'Эпик держит вместе крупный кусок работы: под ним живут истории, задачи и баги.',
      },
      nothingFound: {
        title: 'Ничего не нашлось',
        description: 'Эпики есть, но ни один не подходит под запрос. Проверьте написание.',
      },
    },
    summary: {
      total: '{count} задача | {count} задачи | {count} задач',
      done: '{count} готово',
      inProgress: '{count} в работе',
      open: '{count} открыто',
    },
    progressLabel: 'Готовность эпика',
    empty: 'У эпика пока нет задач',
    pipelines: 'Пайплайны эпика · по сервисам',
    noPipelines: 'Прогонов по задачам эпика ещё не было',
    ops: 'Флаги и стенды',
    activityGap:
      'Ленты событий эпика нет: в трекере есть история одной задачи, общей ленты пока не завели.',
  },
  devops: {
    stand: {
      raise: 'Поднять стенд',
      drop: 'Погасить стенд',
    },
    pipelines: {
      title: 'Пайплайны',
      project: 'Проект',
      allProjects: 'Все проекты',
      unassigned: 'Без задачи',
      status: 'Статус',
      noProjects: 'Выбирать не из чего',
      searchPlaceholder: 'Поиск…',
      groupBy: 'Группировка прогонов',
      byEpic: 'По эпикам',
      byService: 'По сервисам',
      window: 'Окно',
      windowDays: '{days} д',
      open: 'Открыть в GitLab',
      error: 'Не удалось загрузить прогоны',
      errorHint: 'Сводка пайплайнов недоступна. Попробуйте ещё раз.',
      kpi: {
        success: 'Успешно · 24 ч',
        successHint: 'из {total}',
        failed: 'Упало',
        running: 'Идёт сейчас',
        duration: 'Средняя длительность',
        delta: '{delta} с к вчера',
      },
      empty: {
        title: 'Прогонов нет',
        description:
          'Трекер узнаёт о прогонах из вебхуков GitLab: они появятся после первого пуша в ветку задачи.',
      },
    },
    services: {
      add: 'Добавить сервис',
      remove: 'Убрать {name}',
      noRepositories: 'Подключённых репозиториев нет',
      suggested: 'В {name} появилась ветка этой задачи',
      addSuggested: '— добавить в сервисы?',
    },
    envs: {
      title: 'Фича-окружения',
      searchPlaceholder: 'Поиск…',
      refresh: 'Обновить',
      retry: 'Повторить',
      error: 'Не удалось загрузить стенды',
      errorHint: 'GitLab не ответил про окружения. Попробуйте ещё раз.',
      actionError: 'Не удалось выполнить действие — проверьте пайплайн в GitLab.',
      noIssue: 'без задачи',
      noUrl: 'выката ещё не было',
      autoStopIn: 'сносится сам через {time}',
      note: 'Стенд поднимается составом: каждый сервис задачи едет в один namespace dev-NNNN, фронт без своей ветки собирается с master. Ссылки появляются по мере выката — хост есть только у того, что действительно выкачено. «Погасить» сносит стенд целиком: namespace один на все сервисы.',
      columns: {
        stand: 'Стенд',
        issue: 'Задача',
        services: 'Состав',
        actor: 'Поднял',
        uptime: 'Аптайм',
        actions: 'Действия',
      },
      state: {
        active: 'активен',
        building: 'сборка',
        idle: 'простаивает',
        buildingUptime: '—',
      },
      uptime: {
        days: 'д',
        hours: 'ч',
        minutes: 'мин',
      },
      metrics: {
        active: 'Активные стенды',
        activeHint: 'работают сейчас',
        building: 'Поднимаются',
        idle: 'Простаивают > {days} дней',
        idleHint: 'кандидаты на снос',
      },
      filters: {
        project: 'Сервис',
        state: 'Статус',
        noProjects: 'Выбирать не из чего',
      },
      actions: {
        open: 'Открыть стенд',
        redeploy: 'Пересобрать',
        drop: 'Погасить',
        noIssueHint: 'Стенд поднят не из задачи — состав пересборки брать неоткуда',
      },
      empty: {
        title: 'Живых стендов нет',
        description: 'Поднимите стенд из карточки задачи или кнопкой в панели.',
      },
      raise: {
        title: 'Поднять стенд',
        titleFor: 'Поднять стенд {key}',
        namespace: '{stand} · namespace {name} · сносится сам через 3 дня простоя',
        composition: 'Состав — сервисы задачи',
        issue: 'Задача',
        unknownIssue: 'Задачи с таким ключом нет',
        pickIssue: 'Укажите задачу — состав возьмём из неё',
        noServices: 'У задачи не указаны сервисы. Добавьте их в карточке — из них соберётся стенд.',
        servicesFailed: 'Не удалось прочитать сервисы задачи',
        ownBranch: 'своя ветка',
        noOwnBranch: 'ветки задачи нет',
        addService: 'В состав',
      },
    },
    flags: {
      loading: 'Загрузка…',
      button: 'Флаги',
      title: 'Флаги фич',
      note: 'Флаг переключается коммитом в features/dev.json или features/prod.json репозитория инфраструктуры. Git остаётся источником правды, трекер показывает состояние и историю.',
      new: 'Новый флаг',
      newTitle: 'Новый флаг',
      newHint:
        'Флаг заводится сразу в обеих средах: в выбранной — включённым, в соседней — выключенным. Так требует линт инфраструктуры.',
      keyInvalid: 'Ключ вида dev-1476-devops-screens: с номером задачи и в нижнем регистре',
      create: 'Завести флаг',
      error: 'Не удалось загрузить флаги',
      errorHint: 'Файл флагов недоступен: проверьте, настроена ли интеграция с GitLab.',
      toggleError: 'Не удалось переключить флаг',
      recent: 'Последние переключения',
      turnedOn: 'включён на {environment}',
      turnedOff: 'выключен на {environment}',
      noIssue: 'задача не указана в ключе',
      searchPlaceholder: 'Поиск…',
      columns: {
        flag: 'Флаг',
        what: 'Задача',
        changed: 'Последнее изменение',
      },
      filters: {
        environment: 'Среда',
        empty: 'Выбирать не из чего',
      },
      empty: {
        title: 'Флагов пока нет',
        description: 'Заведите первый — он появится в features/dev.json и features/prod.json.',
      },
    },
    repos: {
      title: 'Репозитории',
      sync: 'Сверить сейчас',
      ago: '{time} назад',
      events: 'push · MR · пайплайны',
      noEvents: 'не приходили',
      open: 'Открыть в GitLab',
      connect: 'Подключить',
      recheck: 'Переподключить',
      disconnect: 'Отключить',
      error: 'Не удалось загрузить репозитории',
      empty: 'Репозиториев нет',
      emptyHint: 'Сверка ещё не проходила или в группе нет проектов',
      syncDone: 'Проверено {checked}, подключено {connected}, отказов {failed}',
      syncFailed: 'Сверка не прошла',
      connected: '{path} подключён',
      connectFailed: 'Не удалось подключить репозиторий',
      disconnected: '{path} отключён',
      disconnectFailed: 'Не удалось отключить репозиторий',
      note: 'Групповой вебхук — платная функция GitLab, поэтому хук ставится на каждый репозиторий отдельно. Трекер сверяет список группы по расписанию и доставляет хук туда, где его нет: новый репозиторий подключается сам.',
      filters: {
        state: 'Состояние',
      },
      columns: {
        path: 'Репозиторий',
        events: 'События',
        lastEvent: 'Последнее событие',
        actions: 'Действия',
      },
      state: {
        connected: 'подключён',
        missing: 'нет хука',
        failed: 'хук отключён',
        muted: 'отключён вручную',
      },
      metrics: {
        connected: 'Подключено',
        connectedHint: 'из {total} репозиториев',
        missing: 'Без хука',
        missingHint: 'события не приходят',
        failed: 'С ошибкой',
        failedHint: 'GitLab отклонил хук',
        synced: 'Сверено',
        syncedHint: 'последняя сверка',
      },
    },
    releases: {
      views: {
        label: 'Вид истории',
        flat: 'Списком',
        grouped: 'По репозиториям',
      },
      inRepository: '{n} релиз | {n} релиз | {n} релиза | {n} релизов',
      title: 'Релизы',
      history: 'История релизов',
      searchPlaceholder: 'Поиск…',
      error: 'Не удалось загрузить релизы',
      errorHint: 'Журнал операций недоступен. Попробуйте ещё раз.',
      tagged: 'тег поставлен',
      failed: 'ошибка',
      open: 'Открыть в GitLab',
      note: 'Тег создаётся через GitLab API. Выкат на prod — кнопкой на строке релиза, когда пайплайн дойдёт до ручной джобы.',
      filters: {
        service: 'Сервис',
        period: 'Период',
        days: 'За {days} дней',
        buildLabel: 'Сборка',
        build: {
          success: 'Прошла',
          failed: 'Упала',
          running: 'Идёт',
          none: 'Нет сборки',
        },
        empty: 'Выбирать не из чего',
      },
      order: {
        label: 'Порядок',
        newest: 'Новые сверху',
        oldest: 'Старые сверху',
      },
      noBuild: 'нет сборки',
      deploy: {
        action: 'Выкатить на prod',
        confirmTitle: 'Выкатить {tag} на prod?',
        confirmBody: 'Трекер нажмёт ручную джобу deploy-prod в пайплайне тега — ту же, что вы нажали бы в GitLab. Остановить выкат из трекера нельзя.',
        pipeline: 'пайплайн #{id}',
        submit: 'Выкатить',
        failed: 'Не удалось запустить выкат',
      },
      empty: {
        title: 'Релизов пока нет',
        description: 'Через трекер тегов ещё не ставили. Собранные руками теги журнал не знает.',
      },
    },
    release: {
      button: 'Релиз',
      title: 'Собрать релиз',
      hint: 'Тег ставится на master. Список сервисов — подсказка, репозиторий можно вписать руками.',
      service: 'Сервис',
      tag: 'Версия',
      tagInvalid: 'Версия вида v1.4.0',
      description: 'Описание',
      generate: 'Сгенерировать',
      generating: 'Ассистент читает историю…',
      generated: 'Собрано ассистентом по {commits} коммитам после {tag}. Проверьте перед созданием тега.',
      generateFailed: 'Не удалось собрать описание',
      replaceTitle: 'Заменить набранное описание?',
      replace: 'Заменить',
      create: 'Поставить тег',
    },
  },
}
